import { noop } from "lodash";
import { createContext, useContext, useState } from "react";

const initialValue = {
  isOpen: false,
  setIsOpen: noop,
};

export type RedemptionModalContextType = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const RedemptionModalContext =
  createContext<RedemptionModalContextType>(initialValue);

export function useRedemptionModalContext() {
  return useContext(RedemptionModalContext);
}

export function RedemptionModalContextProvider(props: {
  children: React.ReactNode;
  initialValue?: RedemptionModalContextType;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(
    props.initialValue?.isOpen ?? false,
  );

  const value = {
    isOpen,
    setIsOpen,
  };

  return (
    <RedemptionModalContext.Provider value={value}>
      {props.children}
    </RedemptionModalContext.Provider>
  );
}
